export default {
  lang: (state) => {
    return state.lang;
  },
};
